let showAiSupportedMarking = true;
const listeners = new Set<() => void>();

export const getShowAiSupportedMarking = (): boolean => showAiSupportedMarking;

export const setShowAiSupportedMarking = (show: boolean): void => {
    if (showAiSupportedMarking === show) {
        return;
    }
    showAiSupportedMarking = show;
    listeners.forEach((listener) => listener());
};

/** A newly opened question always starts with AI suggestions on. The choice is not kept. */
export const initShowAiSupportedMarkingForQuestion = (): void => {
    if (showAiSupportedMarking) {
        return;
    }
    showAiSupportedMarking = true;
    listeners.forEach((listener) => listener());
};

export const subscribeShowAiSupportedMarking = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
